export const ourNumbers = {
  clients: "1700",
  reservations: "11",
  resValue: 810 ,
};
